import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import { UnexpectedError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { M8StatementDTO } from 'services/production/types';

type Params = {
  idStatement: number;
};
export const releaseStatement = async (
  params: Params
): Promise<M8StatementDTO> => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8AdminURL('releaseStatement'), {
    method: 'POST',
    body,
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }

  return response.json();
};
